import { getToken } from 'data/auth/utils'
import { EntityId } from 'scenes/Dashboard/data/common/types'
import { FundingEvent } from 'scenes/Dashboard/data/fundingEvents/types'
import { createApiHandler, CreateApiHandlerConfig } from 'services-next/api'
import { ApiCaller, callApi } from 'services/api'

const FUNDING_EVENTS_ENDPOINT_PATH = 'admin/funding-events/organization'

export function getApiFundingEventHandlers(customToken?: string, config: Omit<CreateApiHandlerConfig, 'baseUrl'> = {}) {
  const token = customToken || getToken() || undefined
  const { callApi } = createApiHandler(token, config)

  async function apiGetFundingEvent(organizationId: EntityId): Promise<FundingEvent> {
    const fundingEvent = await callApi<FundingEvent>({
      url: `${FUNDING_EVENTS_ENDPOINT_PATH}/${organizationId}`,
    })
    return fundingEvent
  }

  return {
    apiGetFundingEvent,
  }
}

const apiGetFundingEvent = (apiCaller: ApiCaller) => async (organizationId: EntityId): Promise<FundingEvent> => {
  const fundingEvent = await apiCaller<FundingEvent>({
    url: `${FUNDING_EVENTS_ENDPOINT_PATH}/${organizationId}`,
  })
  return fundingEvent
}

export const apiGetFundingEventAsAdmin = apiGetFundingEvent(callApi)
